import { render, staticRenderFns } from "./AccidentReasons.vue?vue&type=template&id=3d9c7d38"
import script from "./AccidentReasons.vue?vue&type=script&lang=js"
export * from "./AccidentReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports